(function() {
    'use strict';
a3_cabin_reports.factory('ASSFReportFactory', ASSFReportFactory);
                                                   
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name ASSFReportFactory
    * @description 
    *   Add, Update, Delete and Get aircraft security search form reports.
    * @ngInject
    */
function ASSFReportFactory(localStorageMD5Service, FlightFactory, $http, apiUrl, GenericService) { 
        /**
        * Initialize the ASSFReport
        * @memberof ASSFReportFactory
        */
		function ASSFReport() {

			this.flightId = null;
			this.authorId = null;
			this.submissionTimestamp = null;
            this.flightNumber = null;
            this.flightDate = null;
			this.previousFlightOrigin = null;
			this.formVersionId = null;
            this.isRequired = false;
			
            this.searchCompleted = null;
			this.commanderName = null;
			this.commanderSignature = null;
            this.flightCrewName = null;
            this.flightCrewSignature = null;
            this.cabinCrewName = null;
            this.cabinCrewSignature = null;
			this.groundServiceProviderName = null;
			this.groundServiceProviderSignature = null;
            this.notApplicable = false;
            this.areaCategories = [];
            this.status = 'Pending';
			this.GetId = GetId;
		}
		
		var objType = 'ASSFReports';
		var objCallback = ASSFReport;  
				
		var service = 
		{  
			getAssfReportsFromStorage: getAssfReportsFromStorage,
            getAssfReportFromStorage:getAssfReportFromStorage,
            setAssfReportToStorage : setAssfReportToStorage,
            setAssfReportsToStorage: setAssfReportsToStorage,
            updateFlightsAssfStatus: updateFlightsAssfStatus,
            updateFlightAssfStatus: updateFlightAssfStatus,
            cleanOldData: cleanOldData,
            sendReport: sendReport,
            getNewAssfReport : getNewAssfReport,
			getTempAssfReport : getTempAssfReport,
			saveTempAssfReport : saveTempAssfReport,
			clearTempAssfReport : clearTempAssfReport,
		};

		function getAssfReportFromStorage(flightId) {
			return GenericService.get(flightId,objType,objCallback);
		}

		function getAssfReportsFromStorage(){
            var lsItems = GenericService.list(objType,objCallback);
            var items = [];
            for (var i = 0; i < lsItems.length; i++) {
				if (lsItems[i]) {
					items.push(lsItems[i]);
				}
			}
			return items;
        }


        function updateFlightAssfStatus(assfForm){
            //Update the flight status in the local storage
            var flight = FlightFactory.getFlightFromStorage(assfForm.flightId);
            if(flight){
                flight.assfReport = {
                    id: assfForm.id,
                    status: assfForm.status,
                    isRequired: assfForm.isRequired !== undefined && assfForm.isRequired !== null ? assfForm.isRequired : false
                }
                FlightFactory.updateFlight(flight);
            }
        }

        function updateFlightsAssfStatus(syncedFlightIds){
            var flights = FlightFactory.getFlightsFromStorage();
            var oldAssfReports = getAssfReportsFromStorage();
            for (var i = 0; i < flights.length; i++) {
                if (syncedFlightIds && syncedFlightIds.includes(flights[i].flightId)) {
                    flights[i].assfReport = {
                        id: null,
                        status: 'Stored'
                    }
                }
                else {
                    const matchingReport = oldAssfReports.find(report => report.flightId === flights[i].flightId);
                    if (matchingReport) {
                        flights[i].assfReport = {
                            id: matchingReport.id,
                            status: matchingReport.status,
                            isRequired: matchingReport.isRequired !== undefined && matchingReport.isRequired !== null ? matchingReport.isRequired : false
                        }
                    }
                }
			}
			FlightFactory.setFlightsToStorage(flights);
        }

        /**
         * Save the assf report to storage
         * @memberof CrewAssessmentFactory
         * @param {Object} ASSF Report - Aircraft Security Search Form Report
         */
		function setAssfReportToStorage(assfReport) {
            if (assfReport != null){
                if (GenericService.get(assfReport.flightId, objType, objCallback)){
                    GenericService.save(assfReport, objType, objCallback);
                }
                else {
                    GenericService.add(assfReport, objType, objCallback);
                }
            }
		}

        /**
         * Send the assf report to the server
         * @memberof CrewAssessmentFactory
         *  @param {Object} ASSF Report - Aircraft Security Search Form Report
         *  @returns {Promise} A promise that resolves to the response from the server
         **/
        function sendReport(assfReport){    
            if (assfReport != null){
               return $http.post(apiUrl + '/AircraftSecuritySearchForm/SaveSearchReport', assfReport, { 'Content-Type': 'application/json' })
                .then(res => saveReportSuccessCallBack(res, assfReport))
                .catch(res => saveReportFailedCallBack(res));
            }

        }

        function saveReportSuccessCallBack(res, assfReport) {
            if (res.data && res.data.success) {
                // Save the report to local storage
                assfReport.status = 'Stored';
                setAssfReportToStorage(assfReport);
                return res.data;
            } else {
                throw new Error('Failed to save security search form report. Error message:' + res.data.message);
            }
        }
        function saveReportFailedCallBack(res) {
            var errorMessage = res.data && res.data.Message ? res.data.Message : 'Failed to save security search form report';
            throw new Error(errorMessage);
        }

        /**
         * save the assf reports to storage   
         * @memberof CrewAssessmentFactory
         * @param {Array} AssfReports
         */
		function setAssfReportsToStorage(objList) {
			GenericService.saveAll(objList,objType);
        }

        /**
         * Initialize a new AssfReport from the default Constructor
         * @memberof ASSFReportFactory
         * @returns {Object} crewAssesment
         */
		function getNewAssfReport() {
			return GenericService.constructor(objCallback);
		};
        /**
         * Get the Temporary AssfReport from the local storage
         * @memberof ASSFReportFactory
         * @returns {Object} AssfReport
         */
		function getTempAssfReport() {
			var AssfReportLocalEdit = localStorageMD5Service.get('AssfReportLocalEdit_TEMP');
			return fromObject(AssfReportLocalEdit);
		};

        /**
         * Save the Temporary AssfReport to  the local storage
         * @memberof ASSFReportFactory
         * @param {Object} AssfReport 
         * @param {number} FlightId  a crewAssesment
         */
		function saveTempAssfReport(report, flightId) {
            if (report){
                report.flightId = flightId;
                localStorageMD5Service.remove('AssfReportLocalEdit_TEMP');
                localStorageMD5Service.set('AssfReportLocalEdit_TEMP', report);
            }
		};

        /**
         * Remove the Temporary AssfReport of  the local storage
         * @memberof ASSFReportFactory
         */
		function clearTempAssfReport() {
			localStorageMD5Service.remove('AssfReportLocalEdit_TEMP');
		};

        //object functions
        /**
         * Overide default get Id
         * @memberof ASSFReportFactory
         * @returns {number} Id 
         */
		function GetId(){
			return this.flightId;
		}

        /**
         * Extend Object from the default AssfReport Object
         * @memberof ASSFReportFactory
         * @param {Object} obj  a AssfReport
         * @returns {Object} AssfReport
         */
		function fromObject (obj){
			return GenericService.fromObject(obj,objCallback);
		}

        /**
         * Clean ls from old flight previous duties
         * @param {array} flights Synced flights
         */
        function cleanOldData(responseFlightIds){
            var reportsInLS = getAssfReportsFromStorage();
            //Filter out previous duties of old flights
            reportsInLS = reportsInLS.filter(x => responseFlightIds.includes(x.flightId));
            
            setAssfReportsToStorage(reportsInLS);
        }
	    return service;
	}
    
})();